<template>
	<PopupRouterView :showLeftIcon="true" label="Delegation Setting Input"  entityName="delegationsetting" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-delegate-from" label-cols-sm="4" label-cols-lg="3" label="Delegate From" label-for="input-delegate-from" size="sm" :model.sync="model.delegateFrom"   />
				<app-input-textbox id="fieldset-delegate-to" label-cols-sm="4" label-cols-lg="3" label="Delegate To" label-for="input-delegate-to" size="sm" :model.sync="model.delegateTo"   />
				<app-input-datetimepicker  id="fieldset-period-from" label-cols-sm="4" label-cols-lg="3" label="Period From" size="sm" :model.sync="model.periodFrom"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  />
				<app-input-datetimepicker  id="fieldset-period-to" label-cols-sm="4" label-cols-lg="3" label="Period To" size="sm" :model.sync="model.periodTo"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  />
				<b-form-group id="fieldset-is-all-time" label-cols-sm="4" label-cols-lg="3" label="Is All Time" label-for="input-is-all-time">
						<b-form-checkbox id="input-is-all-time" v-model="model.isAllTime"  ></b-form-checkbox>
					</b-form-group>
				<app-input-textarea id="fieldset-remarks" label-cols-sm="4" label-cols-lg="3" label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"   />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DelegationSetting from '@/models/DelegationSetting/DelegationSetting';
import DelegationSettingList from '@/models/DelegationSetting/DelegationSettingList';
import DelegationSettingFilter from '@/filters/DelegationSetting/DelegationSettingFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputDatetimepicker,AppInputDatetimepickerRange,AppInputTextarea,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDelegationSetting : null,
			currentDelegationSettingPage : 1,
			delegationSettingPageSize: 10,
			sortByDelegationSetting: '',
			sortDescDelegationSetting: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDelegationSetting : async function(id) {
			this.isBusy = true;
			DelegationSetting.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDelegationSetting = true;
			this.filterDelegationSetting.id = this.modelId;
			DelegationSetting.downloadDataDetail(this, this.filterDelegationSetting).then(result => {
				this.isDownloadDelegationSetting = false;
			}).catch(error => { this.isDownloadDelegationSetting = false; })
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				DelegationSetting.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'delegationsettingindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				DelegationSetting.insertData(this, model).then(result => {
					this.$router.push({ name: 'delegationsettingindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getDelegationSettings();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDelegationSetting = new DelegationSettingFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDelegationSetting(id);
			} else {
				this.modelId = id;
				this.getDelegationSetting(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
